export default __webpack_public_path__ + "static/media/exploreFilledIcon.e1461882.svg";